/**
 * Anything a kid can drop into the beaker: an element or a compound.
 */
export default class Substance {
  constructor({ id, symbol, name, category, description = '', color = null }) {
    if (new.target === Substance) {
      throw new TypeError('Substance is abstract; use Element or Compound.');
    }
    this.id = id;
    this.symbol = symbol;
    this.name = name;
    this.category = category;
    this.description = description;
    this.color = color;
  }

  isElement() {
    return false;
  }

  getDisplayLabel() {
    return `${this.name} (${this.symbol})`;
  }
}
